import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const data = [
  {
    name: "January",
    count: 4000,
    installed: 2400,
    amt: 2400,
  },
  {
    name: "February",
    count: 3000,
    installed: 1398,
    amt: 2210,
  },
  {
    name: "March",
    count: 2000,
    installed: 9800,
    amt: 2290,
  },
  {
    name: "April",
    count: 2780,
    installed: 3908,
    amt: 2000,
  },
  {
    name: "May",
    count: 1890,
    installed: 4800,
    amt: 2181,
  },
  {
    name: "June",
    count: 2390,
    installed: 3800,
    amt: 2500,
  },
  {
    name: "July",
    count: 3490,
    installed: 4300,
    amt: 2100,
  },
];


const Yields = () => (
  <div className="w-full h-[500px] px-[1.25rem] py-[.75rem] rounded-[.75rem] bg-white shadow-[0px_4px_20px_0px_rgba(7,6,18,0.10)]">
    <div className="graph_h1">Yields Summary</div>
    <ResponsiveContainer width="100%" height="100%">
      <LineChart
        data={data}
        margin={{
          top: 5,
          right: 30,
          left: 5,
          bottom: 20,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis hide={true}/>
        <Tooltip />
        <Legend layout="horizontal" verticalAlign="top" align="center" iconType="circle" />
 
        <Line
          type="monotone"
          dataKey="installed"
          stroke="#13C296"
          activeDot={{ r: 8 }}
        />
        <Line type="monotone" dataKey="count" stroke="#0092CC" />
      </LineChart>
    </ResponsiveContainer>
  </div>
);

export default Yields;
